import PropTypes from 'prop-types'
import { branch, compose, getContext, renderNothing } from 'recompose'
import { connect } from 'react-redux'

import { selectAVMAppreciationPercent } from 'src/store/selectors/home/avm'

const AppreciationSentenceContainer = compose(
  getContext({
    withCurrentHomeData: PropTypes.bool
  }),
  branch(({ withCurrentHomeData }) => !withCurrentHomeData, renderNothing),
  connect(state => ({
    appreciationPercent: selectAVMAppreciationPercent(state)
  })),
  branch(({ appreciationPercent }) => !appreciationPercent, renderNothing)
)

export default AppreciationSentenceContainer
